/* eslint-disable */
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PresenceService = void 0;
var http_1 = require("@wix/ambassador/runtime/http");
var PresenceService = function (baseUrl, httpClientConfig) {
    var httpClient = new http_1.AmbassadorHTTPClient(baseUrl, httpClientConfig);
    return {
        PresenceService: function () {
            return function (headers) {
                var service = {
                    resetScope: function (resetScopeRequest) { return httpClient.invoke('POST', '/api/v1/reset-scope', resetScopeRequest, headers); },
                    setData: function (setDataRequest) { return httpClient.invoke('POST', '/api/v1/set-data', setDataRequest, headers); },
                    watch: function (watchRequest) { return httpClient.invoke('POST', '/api/v1/watch', watchRequest, headers); },
                };
                service.resetScope.__http_method = 'POST';
                service.resetScope.__http_url = '/api/v1/reset-scope';
                service.setData.__http_method = 'POST';
                service.setData.__http_url = '/api/v1/set-data';
                service.watch.__http_method = 'POST';
                service.watch.__http_url = '/api/v1/watch';
                return service;
            };
        },
    };
};
exports.PresenceService = PresenceService;
exports.PresenceService.__transport = 'http';
__exportStar(require("./types"), exports);
//# sourceMappingURL=http.js.map